// extracted by mini-css-extract-plugin
export var adresse = "footer-module--adresse--s2aUN";
export var association = "footer-module--association--KhFbQ";
export var container = "footer-module--container--P4f0P";
export var footer = "footer-module--footer--gdHyf";
export var horaire = "footer-module--horaire--g8g0W";
export var title = "footer-module--title--ACcia";